import { InfoCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import React, { FC } from "react";
import themeColors from "styles/themeColors";
import Tooltip, { TooltipProps } from "../Tooltip";

export type InfoIconTooltipProps = TooltipProps & {
  iconColor?: string;
  iconSize?: number;
  filled?: boolean;
};
const InfoIconTooltip: FC<InfoIconTooltipProps> = ({
  iconColor,
  iconSize = 24,
  filled = true,
  ...props
}) => {
  return (
    <Tooltip {...props}>
      {filled ? (
        <InfoCircleFilled
          style={{
            fontSize: iconSize,
            color: iconColor ? iconColor : themeColors.primary.main,
          }}
        />
      ) : (
        <InfoCircleOutlined
          style={{
            fontSize: iconSize,
            color: iconColor ? iconColor : themeColors.primary.main,
          }}
        />
      )}
    </Tooltip>
  );
};

export default InfoIconTooltip;
